module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/star_early_years-5511a9e3027b0e7f25eb0363dcd09a6f.svg";